import React, { useState, useEffect } from 'react';
import { db, auth } from '../firebase';
import {
  doc,
  getDoc,
  addDoc,
  collection,
  getDocs,
} from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import BackHomeButton from '../components/BackHomeButton';
import { useLocation } from 'react-router-dom';

function BooksDonation() {
  const [name, setName] = useState('');
  const [age, setAge] = useState('');
  const [gender, setGender] = useState('');
  const [school, setSchool] = useState('');
  const [board, setboard] = useState('');
  const [standard, setStandard] = useState('');
  const [city, setCity] = useState('');
  const [user, setUser] = useState(null);
  const [created_dt, setcreated_dt] = useState(null);

  const [cityOptions, setCityOptions] = useState([]);
  const [filteredSchools, setFilteredSchools] = useState([]);
  const [paiduser,setpaiduser] = useState([]);
  const [paidUser_End_Date,setpaidUser_End_Date] = useState([]);
  const [subscriptionMonths,setsubscriptionMonths] = useState([]);

  const [persona,setPersona]=useState('');
  const location = useLocation();

  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const state = location.state;
    
    if (state) {
      if (state.persona) setPersona(state.persona);
    }
  }, [location.state]);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      if (!currentUser) {
        alert('You must be logged in');
        navigate('/login');
      } else {
        setUser(currentUser);
      }
    });

    return () => unsubscribe();
  }, [navigate]);

  // Fetch city-school pairs and group by city
  useEffect(() => {
    const fetchCitySchools = async () => {
      try {
        const citySchoolsSnap = await getDocs(collection(db, 'city_schools_prod'));
        const citySchoolMap = {};

        citySchoolsSnap.forEach((doc) => {
          const data = doc.data();
          if (!citySchoolMap[data.city]) {
            citySchoolMap[data.city] = [];
          }
          if (!citySchoolMap[data.city].includes(data.school)) {
            citySchoolMap[data.city].push(data.school);
          }
        });

        const cities = Object.keys(citySchoolMap).sort();
        setCityOptions(cities);

        if (city && citySchoolMap[city]) {
          setFilteredSchools(citySchoolMap[city]);
        } else {
          setFilteredSchools([]);
        }
      } catch (error) {
        console.error('Error fetching city-schools:', error);
      }
    };

    fetchCitySchools();
  }, [city]);

  // Load existing profile data
  useEffect(() => {
    const fetchUserProfile = async () => {
      if (user) {
        try {
          const profileDoc = await getDoc(doc(db, 'profiles', user.uid));
          if (profileDoc.exists()) {
            const profileData = profileDoc.data();
            setName(profileData.name || '');
            setAge(profileData.age || '');
            setGender(profileData.gender || '');
            setSchool(profileData.school || '');
            setStandard(profileData.standard || '');
            setCity(profileData.city || '');
            setcreated_dt(profileData.created_dt || '');
            setpaiduser(profileData.paidUser || false);
            setpaidUser_End_Date(profileData.paidUser_End_Date || '');
            setsubscriptionMonths(profileData.subscriptionMonths || 0);
            setboard(profileData.board || '');
          }
        } catch (err) {
          console.error('Error fetching profile data:', err);
        }
      }
    };

    fetchUserProfile();
  }, [user]);

  // Update filtered schools when city changes
  useEffect(() => {
    const updateSchoolsForCity = async () => {
      try {
        const citySchoolsSnap = await getDocs(collection(db, 'city_schools_prod'));
        const citySchoolMap = {};

        citySchoolsSnap.forEach((doc) => {
          const data = doc.data();
          if (!citySchoolMap[data.city]) {
            citySchoolMap[data.city] = [];
          }
          if (!citySchoolMap[data.city].includes(data.school)) {
            citySchoolMap[data.city].push(data.school);
          }
        });

        if (city && citySchoolMap[city]) {
          setFilteredSchools(citySchoolMap[city]);
        } else {
          setFilteredSchools([]);
        }
      } catch (error) {
        console.error('Error updating schools:', error);
      }
    };

    if (city) {
      updateSchoolsForCity();
    } else {
      setFilteredSchools([]);
      setSchool('');
    }
  }, [city]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!user) {
      alert('User not logged in');
      return;
    }

    if (!city.trim() || !school.trim()) {
      alert('Please enter both city and school.');
      return;
    }

    try {
      // Save donation

          const rewardref = await addDoc(collection(db, 'Books_Donation'), {
                name,
                school,
                standard,
                city,
                email: user.email,
                uid: user.uid,
                created_dt: new Date(),
                updated_dt: new Date(),
          });

  
      alert('Awesome thanks for your help! Donation Saved');
      navigate('/Old_Home', { state: { persona } });
    } catch (error) {
      console.error('Error saving profile:', error);
      alert('Something went wrong.');
    }
  };

  return (
    <div style={styles.page}>
      <h2 style={styles.heading}>Donate Books</h2>

      <ul style={styles.list}>
        <li>*   Below details are uneditable . </li>
        <li>*   We have kept the same school and standard as you last completed academic year.</li>
      </ul>

      <div style={styles.donorLabel}>
  <h3 style={styles.heading_inner}>📚 To Our Amazing Book Donors</h3>

  <ul style={styles.list}>
    <li>🌟 You’re a special kind of parent — because you believe knowledge should be shared, not stored away.</li>
    <li>💛 You’re teaching generosity by example. Your child sees that giving matters.</li>
    <li>🌍 You’re building a stronger community, one thoughtful act at a time.</li>
  </ul>
       </div>

       <br></br>


      <form onSubmit={handleSubmit} style={styles.form}>

        <label style={styles.label}>Student Name:</label>
        <input
          value={name}
          disabled
          style={styles.input}
        />

      <label style={styles.label}>City:</label>
<select
  style={styles.input}
  value={city}
  disabled
>
  <option value="">Select a city</option>
  {cityOptions.map((c, idx) => (
    <option key={idx} value={c}>{c}</option>
  ))}
</select>

<label style={styles.label}>School for which donating:</label>
<select
  style={styles.input}
  value={school}
>
  <option value="">Select a school</option>
  {filteredSchools.map((s, idx) => (
    <option key={idx} value={s}>{s}</option>
  ))}
</select>

        <label style={styles.label}>Standard For which donating:</label>
        <select
          value={standard}
          style={styles.select}
          onChange={(e) => setStandard(e.target.value)}
        >
          <option value="">Select Standard</option>
          <option value="LKG">LKG</option>
          <option value="UKG">UKG</option>
          {[...Array(12)].map((_, i) => (
            <option key={i + 1} value={i + 1}>{i + 1}</option>
          ))}
        </select>

<div style={styles.rules}>
  <h3 style={styles.heading_inner}>📚 Process of Donation</h3>

  <ul style={styles.list}>
    <li>*   We only share your email with the requestor and no other detail, ever</li>
    <li>*   We will mail you with the requestor details as soon as we get a match for your donation.</li>
    <li>*   The Requestor will initiate and reach out to you to arange a pickup or delivery (eg rapido/porter etc.) of the books over email.</li>
    <li>*   The Requestor has to pay for any charges related to the pickup or delivery of the books.</li>
    <li>*   You agree to provide only the books in an acceptable condition.</li>
    <li>*   A single Requestor will be matched to your donation request on a first requested first served basis.</li>
  </ul>
       </div>

       <br></br>

<div>
      <div
        style={styles.headerRow}
        onClick={() => setOpen(!open)}
      >
        <span style={styles.icon}>📚 Terms and Conditions {open ? "▲" : "▼"}</span>
      </div>

      {open && (
        <ul style={styles.list}>
          <li>
            Eascode is only facilitating as a platform to connect the donor
            with the requestor. We cannot be held accountable for any outcomes
            from this donation. Eascode is not responsible for any conversation
            or events you have with the matched donor outside of our platform.
          </li>
          <li>
            Please let us know immediately at eascode.ltd@gmail.com if you wish
            to cancel your donation or in case of any issues with the exchange
            of books.
          </li>
          <li>
            Do not raise duplicate donation requests.
          </li>
        </ul>
      )}
    </div>

       <br></br>

        <button type="submit" style={styles.button}  >Agree and Donate Books</button>
      </form>

      <br></br>

      <BackHomeButton style={{ marginTop: '2rem' }} backState={{persona}} />

      <footer style={styles.footer}>
        <p style={styles.footerText}>© 2026 Eascode All Rights Reserved.</p>
      </footer>
    </div>
  );
}

const styles = {
  page: {
    maxWidth: '480px',
    margin: '2rem auto',
    padding: '1.5rem 2rem',
    backgroundColor: '#fff',
    borderRadius: '12px',
    boxShadow: '0 4px 14px rgba(0,0,0,0.1)',
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  heading: {
    textAlign: 'center',
    marginBottom: '1.8rem',
    color: '#333',
    fontWeight: '700',
    fontSize: '1.9rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    marginBottom: '0.3rem',
    fontWeight: '600',
    color: '#555',
  },
  input: {
    padding: '0.6rem 0.9rem',
    fontSize: '1rem',
    borderRadius: '8px',
    border: '1.5px solid #bbb',
    marginBottom: '1.25rem',
    transition: 'border-color 0.3s ease',
  },
  select: {
    padding: '0.6rem 0.9rem',
    fontSize: '1rem',
    borderRadius: '8px',
    border: '1.5px solid #bbb',
    marginBottom: '1.25rem',
    backgroundColor: '#fff',
    transition: 'border-color 0.3s ease',
  },
  button: {
    padding: '0.75rem',
    fontSize: '1.1rem',
    fontWeight: '600',
    backgroundColor: '#4285f4',
    color: '#fff',
    border: 'none',
    borderRadius: '10px',
    cursor: 'pointer',
    boxShadow: '0 4px 12px rgba(66,133,244,0.6)',
    transition: 'background-color 0.3s ease',
  },
  footer: {
    padding: '1rem',
    backgroundColor: '#333',
    color: '#fff',
    textAlign: 'center',
    marginTop: '3rem',
  },
  footerText: {
    fontSize: '0.9rem',
  },
  donorLabel: {
    background: "linear-gradient(135deg, #fff3cd, #ffe0b2)",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    marginTop: "20px",
  },
    rules: {
    background: "linear-gradient(135deg, #f4f2ed, #b7b5b4)",
    padding: "20px",
    borderRadius: "12px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
    marginTop: "20px",
  },
  heading_inner: {
    marginBottom: "12px",
    color: "#b45309",
  },
  list: {
    listStyle: "none",
    paddingLeft: "0",
    lineHeight: "1.8",
    color: "#5c3d00",
    fontSize: '0.9rem',
  },
};

export default BooksDonation;
